import {
  Card,
  CardHeader,
  Content,
  MainInfo,
  PlanPrice,
  PlanPages,
  Divider,
  DetailedInfo,
  InfoText,
  PaperInfoText,
  PlanName,
} from '../styles';
import { IPlanInfo } from '../../types';

interface PlanCardProps {
  planInfo: IPlanInfo;
  showPaper: boolean;
  paperAddOnLabel: string;
  id?: string;
}

export const PlanCard = ({
  planInfo,
  showPaper,
  paperAddOnLabel,
  id,
}: PlanCardProps) => {
  const {
    basePrice,
    priceWithPaper,
    name: planName,
    pages,
    rolloverPages,
    additionalPages,
  } = planInfo;
  const planPrice = showPaper ? priceWithPaper : basePrice;

  return (
    <Content>
      <Card>
        <CardHeader>
          <PlanName>{planName}</PlanName>
        </CardHeader>
        <MainInfo>
          <PlanPrice id={`${id}-plan-price`}>{planPrice}</PlanPrice>
          <PlanPages>{pages}</PlanPages>
          <Divider />
        </MainInfo>
        <DetailedInfo>
          <InfoText>{rolloverPages}</InfoText>
          <InfoText>{additionalPages}</InfoText>
          {showPaper && (
            <PaperInfoText id={`${id}-paper-info-text`}>
              {paperAddOnLabel}
            </PaperInfoText>
          )}
        </DetailedInfo>
      </Card>
    </Content>
  );
};
